import { takeLatest, call, put, delay } from "redux-saga/effects"
import { hideAlert, showAlertAction } from "../actions/alertActions"
import {
	createCaseRequestFailed,
	createCaseRequestFailedClear,
	createCaseRequestSuccess,
	getCaseListRequestFailed,
	getCaseListRequestFailedClear,
	getCaseListRequestSuccess,
} from "../actions/bifrostActions"
import { clearMultibase } from "../actions/multiAiBase"
import { logoutUser } from "../actions/userActions"
import { createCaseService, getCaseListService } from "../services/bifrostServices"
import { CREATE_CASE_REQUEST, GET_CASE_LIST_REQUEST } from "../types"
import { CLIENT_SIDE_MESSAGES as Messages, clearLocalStorage } from "../utils"
import axiosClient from "axios"

function* createCaseSaga(action) {
	try {
		const data = action.payload
		const result = yield call(createCaseService, data)

		if (result.status === 200 && result.data.success === true) {
			yield put(createCaseRequestSuccess(result.data.case)) //update store
		} else {
			yield put(createCaseRequestFailed(result))
		}
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error?.response?.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(createCaseRequestFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(createCaseRequestFailedClear())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* getCaseListSaga(action) {
	try {
		const result = yield call(getCaseListService)

		if (result.status === 200 && result.data.success === true) {
			yield put(getCaseListRequestSuccess(result.data.cases)) //update store
		} else {
			yield put(getCaseListRequestFailed(result))
		}
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response?.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(getCaseListRequestFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(getCaseListRequestFailedClear())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

export default function* bifrostSaga() {
	yield takeLatest(CREATE_CASE_REQUEST, createCaseSaga)
	yield takeLatest(GET_CASE_LIST_REQUEST, getCaseListSaga)
}
